import { ComparisonSection } from '../components/ComparisonSection';
import { ContentAccordion } from '../components/ContentAccordion';
import { EliteGift } from '../components/EliteGift';
import { FaqSection } from '../components/FaqSection';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Hero } from '../components/Hero';
import { ProblemsSection } from '../components/ProblemsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { SystemSection } from '../components/SystemSection';
import { TrustStrip } from '../components/TrustStrip';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-white font-body text-navy" data-id="element-196" data-mp="2g0oz5tzlfv7s">
      <Hero data-id="element-197" data-mp="qjxpcnnithv0" />
      <TrustStrip data-id="element-198" data-mp="qlqz4btfki78" />
      <ReviewsSection data-id="element-199" data-mp="qkzc3pdwfssk" />
      <ProblemsSection data-id="element-200" data-mp="qmk5vcse37pd" />
      <SystemSection data-id="element-201" data-mp="lm5xftmvlvqt" />
      <ContentAccordion type="tomos" data-id="element-202" data-mp="lmo13bbvbc8r" />
      <ContentAccordion type="bonos" data-id="element-203" data-mp="lnpg1qw08ivr" />
      <EliteGift data-id="element-204" data-mp="2zjgpqv8fs0ch" />
      <ReviewsSection reviewSet="final" data-id="element-205" data-mp="2zjyihhvw3wfn" />
      <GuaranteeSection data-id="element-206" data-mp="2zguasaj7uik8" />
      <FaqSection data-id="element-207" data-mp="33k8zrqp4u99t" />
      <ComparisonSection data-id="element-208" data-mp="33jqy2ejpb2ui" />
      <FinalOffer data-id="element-209" data-mp="33l1xk2645oft" />
      <Footer data-id="element-210" data-mp="33ifticiflr2c" />
    </main>;
}